import { useSignedUrl } from '@/hooks/useSignedUrl';

/**
 * Avatar image that resolves signed URLs for private storage buckets.
 * Drop-in replacement for <img> in places where storage URLs are used.
 */
export function SignedImage({
    src,
    alt,
    className,
    fallback,
}: {
    src: string | null | undefined;
    alt?: string;
    className?: string;
    fallback?: React.ReactNode;
}) {
    const signedUrl = useSignedUrl(src);

    if (!signedUrl) {
        return fallback ?? null;
    }

    return <img src={signedUrl} alt={alt} className={className} />;
}
